import { styled } from 'styled-components';

import commonEssence from 'assets/rewards/common-essence.png';
import { Horizontal } from 'atoms/layout/flex';
import { LabelM } from 'atoms/typography';

const CommonEssenceIcon = styled.img.attrs({ src: commonEssence, alt: '' })`
  height: 1.1em;
`;

type Props = {
  price?: Nullable<number>;
};

export const CommonCardPrice = ({ price }: Props) => {
  return (
    <LabelM bold>
      <Horizontal>
        <CommonEssenceIcon />
        {price || 'N/A'}
      </Horizontal>
    </LabelM>
  );
};
